const systemDict = {
  state: {
    orderCause: [],
    carTypeArr: [],
  },
  mutations: {
    CHANGE_CAUSEOPT(state, list) {
      state.orderCause = list
    },
    CHANGE_CARTYPE(state, list) {
      state.carTypeArr = list
    },
  },
  actions: {},
}

export default systemDict
